import { ActivatedRoute } from '@angular/router';
import { VehicleService } from 'app/services/vehicle.service';
import { LookupInternalModel, LookupModel } from 'app/models/shared/lookup.model';
import { ContactService } from 'app/services/contact.service';
import { FieldGroupModel } from 'app/models/shared/fieldGroup.model';
import { FieldModel } from 'app/models/shared/field.model';
import { ModalController, AlertController, LoadingController, PopoverController, ActionSheetController, Platform } from '@ionic/angular';
import { VehicleAdminModel, VehicleModel } from 'app/models/dms/vehicle.model';
import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';

import { GeneralService } from 'app/services/general.service';

import { LookupInternalCollection, SalesStatus, ContactClass, SecurityRight, VehicleStatusEnum } from 'app/utility/enums';

import { ListItemModel } from 'app/models/shared/listItem.model';
import { TabModel } from 'app/models/shared/tab.model';
import { UserService } from 'app/services/user.service';
import { Title } from '@angular/platform-browser';
import { EditorPageComponent } from 'app/components/shared/editor-page/editor-page.component';
import { StorageService } from 'app/services/storage.service';
import { Constants } from 'app/utility/constants';
import { filterVehicleStatusesForCurrentVehicle } from 'app/utility/vehicle-status.util';

@Component({
    selector: 'app-vehicle-status-selector',
    templateUrl: './vehicle-status-selector.component.html',
    styleUrls: ['./vehicle-status-selector.component.scss'],
    standalone: false
})
export class VehicleStatusSelectorComponent extends EditorPageComponent implements OnInit
{

    @Input() vehicle: VehicleModel;
    editVehicle: VehicleModel;

    public statuses: ListItemModel[];
    statusLookups: LookupInternalModel[];

    constructor(
        public contactService: ContactService,
        public generalService: GeneralService, //for lookups - todo: remove
        public userService: UserService,
        public vehicleService: VehicleService,
        public route: ActivatedRoute,
        public titleService: Title,
        public storage: StorageService,
        public alertController: AlertController,
        public popoverController: PopoverController,
        public actionSheetController: ActionSheetController,
        public loadingController: LoadingController,
        protected cd: ChangeDetectorRef,
        public modalController: ModalController,
        public platform: Platform
    )
    {
        super(userService, route, titleService, storage, alertController, popoverController, actionSheetController, loadingController, cd, platform);
        this.editActive = true;
    }

    skeleton: boolean = false;
    mcOnInit()
    {
        this.setEdit(true);
        this.skeleton = true;
        this.editVehicle = Object.create(this.vehicle);

        if (!this.userService.hasUserRights([SecurityRight.VehiclesTabsAdmin, SecurityRight.VehiclesTabsAdminEdit]) ||
            !this.vehicle.vehicleAdmin
        )
        {
            this.presentAlert("Permission Error", "Sorry you do not have permission to edit vehicle status.");
            setTimeout(() =>
            {
                this.dismissTheModal(false);
            }, 1000);
            return;
        }
        this.getLookups();
    }


    //override from parent
    public ionViewDidEnter()
    {
    }


    public setupFieldGroups(makeDirty: boolean = false): void
    {
        this.fieldGroupTabs = [];
        var field_groups = this.getFieldGroups("general");
        this.fieldGroupTabs.push(new TabModel("Admin", this.vehicle.vehicleAdmin, field_groups, makeDirty, "admin", "", true, true));
        this.skeleton = false;
    }

    async presentAlert(title: string, message: string, back: boolean = false)
    {
        this.userService.presentAlert(title, message, back);
    }

    public getFieldGroups(groupId: string): FieldGroupModel[]
    {

        var field_groups = [];
        switch (groupId)
        {
            case "general":
                var field_group = new FieldGroupModel("Set Vehicle Status");

                var statusSelector;
                //statusSelector = new FieldModel('Status', this.newStatusId, 'lookup', 'vehicleStatusId', true, false, this.newStatus, '', this.vehicle.vehicleClass);
                statusSelector = new FieldModel('Status', this.editVehicle.vehicleAdmin.vehicleStatusId, 'select', 'vehicleStatusId', true, false, this.statuses, '');
                statusSelector.showBoxes = true;
                field_group.addField(statusSelector);

                this.editVehicle.vehicleAdmin.vehicleStatusSup.salesStatus = SalesStatus.Reconditioning;
                if (this.editVehicle.vehicleAdmin.vehicleStatus.caption == "At Supplier")
                {
                    // var supplier = new FieldModel('Supplier', this.editVehicle.vehicleAdmin.vehicleStatusSupId, 'select', 'vehicleStatusSupId', true, false, this.suppliers);
                    this.editVehicle.vehicleAdmin.vehicleStatusSup.contactClass = ContactClass.All;
                    var supplier = new FieldModel('Supplier', this.editVehicle.vehicleAdmin.vehicleStatusSupId, 'contact', 'supplierId', true, false, this.editVehicle.vehicleAdmin.vehicleStatusSup);

                    field_group.addField(supplier);
                }
                else
                {
                    field_group.addField(new FieldModel('Status Comment', this.editVehicle.vehicleAdmin.vehicleStatusDesc, 'longtext', 'vehicleStatusDesc', true, false, null));
                }
                field_groups.push(field_group);
                break;
        }
        return field_groups;
    }


    protected getLookups(): void
    {
        // console.log('getLookups');
        this.generalService.getCachedInternalLookups(LookupInternalCollection.VehicleStatus)
            .subscribe(x =>
            {
                this.statusLookups = x;
                this.statuses = x.map<ListItemModel>(y => new ListItemModel(y.id.toString(), y.caption));
                this.statuses = filterVehicleStatusesForCurrentVehicle(this.statuses, this.vehicle.vehicleAdmin.vehicleStatus.caption);

                this.setupFieldGroups();

            });
    }


    isDirty: boolean = false;
    async cancelModal()
    {
        if (this.isDirty)
        {
            //prompt user to save
            const alert = await this.alertController.create({
                header: "Unsaved changes",
                message: "Some data has changed. Do you want to close without saving?",
                buttons: [
                    {
                        text: 'Cancel',
                        role: 'cancel',
                        cssClass: 'primary',
                        handler: () =>
                        {
                            //do nothing
                            return;
                        }
                    },
                    {
                        text: 'OK',
                        cssClass: 'danger',
                        handler: () =>
                        {
                            this.dismissTheModal(false);
                        }
                    }
                ]
            });

            await alert.present();
        }
        else
        {
            this.dismissTheModal(false);
        }
    }

    async dismissTheModal(save: boolean)
    {
        if (save)
        {

            //if the status is being set to on yard, prompt user to confirm
            if (this.editVehicle.vehicleAdmin.vehicleStatus.member == VehicleStatusEnum.OnYard && this.userService.hasUserRights([SecurityRight.VehiclesTabsPurchaseEdit]))
            {
                const alert = await this.alertController.create({
                    header: "Confirm",
                    message: "Would you like to set the Date On Yard for this vehicle to today's date?",
                    buttons: [
                        {
                            text: 'No',
                            cssClass: 'primary',
                            handler: () =>
                            {
                                this.saveVehicleStatusInfo(save, false);
                            }
                        },
                        {
                            text: 'Yes',
                            cssClass: 'primary',
                            handler: () =>
                            {
                                this.saveVehicleStatusInfo(save, true);
                            }
                        }
                    ]
                });

                await alert.present();
            }
            else
            {
                this.saveVehicleStatusInfo(save, false);
            }

        }
        else
        {
            //console.log("dismiss the modal");
            // Dismiss the top modal returning some data object
            this.modalController.dismiss({
                'result': {
                    save: save
                }
            });
        }
    }

    async saveVehicleStatusInfo(save: boolean, setOnYardDate: boolean)
    {
        if (!this.userService.mcMinVersion("3.2.19"))
        {
            this.saveVehicleAdmin(save);
            return
        }
        else
        {
            const loading = await this.loadingController.create({
                message: 'Saving',
                duration: 60000
            });
            await loading.present();

            var vehicleAdmin = this.editVehicle.vehicleAdmin
            this.vehicleService.saveVehicleStatusInfo(vehicleAdmin.vehicleId, vehicleAdmin.vehicleStatus.member, vehicleAdmin.vehicleStatusDesc, vehicleAdmin.vehicleStatusSupId, setOnYardDate)
                .subscribe({
                    next: x =>
                    {
                        loading.dismiss();
                        // Dismiss the top modal returning some data object
                        this.modalController.dismiss({
                            'result': {
                                save: save,
                                vehicle: this.editVehicle
                            }
                        });
                    },
                    error: err =>
                    {
                        loading.dismiss();

                        this.handleError(err);
                    }});
        }
    }


    async saveVehicleAdmin(save: boolean)
    {

        const loading = await this.loadingController.create({
            message: 'Saving',
            duration: 60000
        });
        await loading.present();
        this.editVehicle.vehicleAdmin.forceStatusHistorySave = true;
        this.vehicleService.saveVehicleAdmin(this.editVehicle.vehicleAdmin).subscribe({
            next: x =>
            {
                this.vehicle = x;
                loading.dismiss();
                // Dismiss the top modal returning some data object
                this.modalController.dismiss({
                    'result': {
                        save: save,
                        vehicle: x
                    }
                });
            },
            error: err =>
            {
                loading.dismiss();
                this.handleError(err);
            }
        });

    }

    async handleFieldChangedAdditional(ev: any)
    {
        if (!(ev.detail && ev.detail.value && ev.detail.id)) return;

        // console.log(ev);
        switch (ev.detail.id)
        {
            case "vehicleStatusId":
                var newStatus = this.statusLookups.filter(x => x.id == ev.detail.value).shift();

                if (newStatus)
                {
                    this.editVehicle.vehicleAdmin.vehicleStatus = newStatus;
                    this.editVehicle.vehicleAdmin.vehicleStatusId = ev.detail.value;
                }
                setTimeout(() =>
                {
                    this.setupFieldGroups();
                }, 50);
                break;
            case "vehicleStatusDesc":
                this.editVehicle.vehicleAdmin.vehicleStatusDesc = ev.detail.value;
                break;
            case "supplierId":
            case "vehicleStatusSupId":
                this.editVehicle.vehicleAdmin.vehicleStatusSupId = ev.detail.value;
                break;
        }
    }



}
